import * as React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>Privacy Policy | RoastMyListing.ai</title>
          <meta name="description" content="Privacy Policy for RoastMyListing.ai - Protecting your data while we roast your listings" />
        </Helmet>
        
        {/* Header with logo */}
        <div style={{ 
          width: '100%', 
          backgroundColor: '#3b82f6',
          background: 'linear-gradient(135deg, #4f46e5 0%, #3b82f6 100%)',
          padding: '8px 0', 
          marginBottom: '2px',
          boxShadow: '0 1px 4px rgba(66, 133, 244, 0.2)'
        }}>
          <div style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0 20px',
            gap: '4px' 
          }}>
            <div 
              onClick={() => navigate('/')}
              style={{ 
                cursor: 'pointer',
                display: 'inline-block',
                textAlign: 'center',
                marginBottom: '0'
              }}
            >
              <img 
                src="/logo.png" 
                alt="RoastMyListing.ai Logo"
                style={{ 
                  maxWidth: '300px', 
                  height: 'auto'
                }}
              />
            </div>
          </div>
        </div>
        
        {/* Main content */}
        <div style={{ 
          maxWidth: '900px', 
          margin: '40px auto', 
          padding: '0 20px',
          color: '#333',
          lineHeight: '1.6'
        }}>
          <h1 style={{ 
            fontSize: '2.5rem', 
            marginBottom: '30px',
            textAlign: 'center',
            color: '#1f2937'
          }}>
            Privacy Policy
          </h1>
          
          <div style={{ marginBottom: '30px' }}>
            <p style={{ marginBottom: '15px' }}>
              <strong>Last Updated:</strong> March 21, 2025
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>1. Introduction</h2>
            <p>
              Sellers Arena Inc. DBA Seller Synapse ("we," "our," or "us") operates the RoastMyListing.ai website (the "Service"). This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>2. Information Collection and Use</h2>
            <p>
              We collect several different types of information for various purposes to provide and improve our Service to you:
            </p>
            <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
              <li><strong>Personal Data:</strong> While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). This may include, but is not limited to your email address, Amazon ASIN information, and usage data.</li>
              <li><strong>Usage Data:</strong> We may also collect information on how the Service is accessed and used ("Usage Data"). This may include information such as your computer's Internet Protocol address (IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers, and other diagnostic data.</li>
            </ul>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>3. Use of Data</h2>
            <p>
              Sellers Arena Inc. DBA Seller Synapse uses the collected data for various purposes:
            </p>
            <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
              <li>To provide and maintain our Service</li>
              <li>To notify you about changes to our Service</li>
              <li>To provide customer support</li>
              <li>To gather analysis or valuable information so that we can improve our Service</li>
              <li>To monitor the usage of our Service</li>
              <li>To detect, prevent and address technical issues</li>
              <li>To provide you with news, special offers and general information about other goods, services and events which we offer</li>
            </ul>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>4. Cookies and Tracking Technology</h2>
            <p>
              We use cookies and similar tracking technologies to track activity on our Service and hold certain information. Cookies are files with small amount of data which may include an anonymous unique identifier.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>5. Affiliate Programs</h2>
            <p>
              Our Service may contain links to Amazon products and services using the Amazon Associates Program, which means we may earn commissions when you click on or make purchases through these links. We may also participate in other affiliate advertising programs for products and services we believe you may find useful.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>6. Service Changes</h2>
            <p>
              We reserve the right to change our Service from free to paid services at any time if the current model cannot be sustained. We will provide notice of such changes through our website or via email if you've signed up for notifications.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>7. Security</h2>
            <p>
              The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>8. Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>9. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us:
            </p>
            <p>
              By email: support@sellersarena.com
            </p>
          </div>
        </div>
      </div>
    </HelmetProvider>
  );
};

export default PrivacyPolicy;
